import styled from "styled-components/macro";

export const InitialAssessmentContainer = styled.div`
  max-width: var(--containerSize);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
